import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { changeYandexMarket } from '../../../actions/yandex';
import MarketCommonApi from '../../../API/market/common-api';
import MarketYandexApi from '../../../API/market/yandex-api';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, SendButton } from '../../../components/Basic/Buttons';
import { Link } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { Input, Select } from '../../../components/Basic/Inputs';
import { TextGrey } from '../../../components/Basic/WrapsStyle';
import MarketProvidersDateUpdate from '../../../components/Markets/Blocks/MarketProvidersDateUpdate';
import {
  MARKETS_MAP,
  TYPE_BUTTONS,
  YANDEX_1,
  YANDEX_2,
  YANDEX_3,
  YANDEX_4,
  YANDEX_5,
  YANDEX_6,
  YANDEX_7,
  YANDEX_8,
  YANDEX_MARKET_IP,
  YANDEX_MARKET_NAME,
  YANDEX_MARKETS_MAP,
} from '../../../constans';
import styles from './styles.module.scss';
import CatalogTableYandex from './Table';

const YandexPage = () => {
  const shop = useSelector((store) => store.yandex.market);
  const location = useLocation();

  const [isFbsRemainsMode, setIsFbsRemainsMode] = useState(location.pathname === '/fbo/fbsyandex')
  const [providerData, setProviderData] = useState({ status_stock: '', date_stock_update: null });
  const [provider, changeProvider] = useState();
  const [providers, setProviders] = useState([]);
  const allProviders = useSelector((store) => store.providers);
  const user = useSelector((store) => store.user);
  const [marketInfo, setMarketInfo] = useState({});
  const [update, setUpdate] = useState(false)

  const dispatch = useDispatch();

  useEffect(() => { }, [update])

  useEffect(() => {
    MarketCommonApi.getMarketInfo({ data: { market: 'yandex' } }).then((r) => setMarketInfo(r.marketInfo));

  }, [])

  const updateProviderStocks = async (providerId = undefined, isNullStock = false, offerIds = undefined) => {
    return await MarketYandexApi.updateStocks(
      {
        data: {
          shop: MARKETS_MAP[shop],
          filter: {
            providerId,
            offerIds,
          },
          rules: {
            nullProvider: isNullStock,
            nullWarehouse: isNullStock,
          },
        },
      });
  };

  const updateProviderPrice = async (providerId = undefined, offerIds = undefined, ignoreDiffPrice, isFbsRemainsMode) => {
    return await MarketYandexApi.updatePrices(
      {
        data: {
          shop: MARKETS_MAP[shop],
          filter: {
            providerId,
            offerIds,
            ...(isFbsRemainsMode && { onlyActiveFbsProducts: true })
          },
          rules: {
            ignoreDiffPrice,
          },
          skladName: 'msk',
        },
      }
    );
  };

  const updateWarehouseStocks = async (isNullStock = false) => {
    await MarketYandexApi.updateStocks(
      {
        data: {
          shop: MARKETS_MAP[shop],
          filter: {
            onlyWarehouse: true,
          },
          rules: {
            nullWarehouse: isNullStock,
          },
        },
      });
  };

  useEffect(() => {
    const p = allProviders.filter((item) => !item['hide']);
    if (p.length > 0) {
      setProviders(p);
      changeProvider(p[0] || {});
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  useEffect(() => {
    if (provider) {
      setProviderData(provider.markets_update[YANDEX_MARKETS_MAP[shop]]);
    }
  }, [provider, shop]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <Content>
      {/* <Row style={{ alignItems: 'stretch', margin: '10px 0' }}> */}
      <Row style={{ alignItems: 'flex-start' }}>
        <WhiteBlock
          title="Управление"
          title_bold={`Yandex ${YANDEX_MARKET_NAME[shop]} (${YANDEX_MARKET_IP[shop]})`}
          style={{ marginRight: '30px' }}
          // style={{ marginRight: '30px', marginBottom: '10px', minWidth: '700px' }}
          minimize={!isFbsRemainsMode}
        >
          <Row style={{ alignItems: 'stretch' }}>
            <Column style={{ marginRight: '20px' }}>
              <Row
                style={{ marginBottom: '15px' }}
              >
                <Select
                  label="Магазин"
                  select={shop}
                  width="200px"
                  valueFn={(f) => YANDEX_MARKET_NAME[f]}
                  style={{ marginBottom: '10px' }}
                  list={[YANDEX_1, YANDEX_2, YANDEX_3, YANDEX_4, YANDEX_5, YANDEX_6, YANDEX_7, YANDEX_8]}
                  onSelect={(v) => dispatch(changeYandexMarket(v))}
                />
                {isFbsRemainsMode && (
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    onClick={() => {
                      MarketYandexApi.loadCards({ data: { shop: MARKETS_MAP[shop], onlyFbsActive: true } })
                      MarketYandexApi.loadPricesAndQuantum({ data: { shop: MARKETS_MAP[shop], onlyFbsActive: true } })
                    }}
                    style={{ marginLeft: '20px' }}
                  >
                    Выгрузить данные
                  </Button>
                )}
              </Row>

              {isFbsRemainsMode &&
                <Column>
                  <Row>
                    <SendButton
                      sendData={{ data: { shop: MARKETS_MAP[shop] } }}
                      sendApi={MarketYandexApi.uploadStocksAndPrices}
                      style={{ marginRight: '15px' }}
                      endLoad={() => setUpdate(!update)}
                    >
                      Подгрузить остатки
                    </SendButton>
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      onClick={() => {
                        MarketYandexApi.excelStocksAndPricesTmp({ data: { shop: MARKETS_MAP[shop] } })
                      }}
                      style={{ marginLeft: '10px' }}
                    >
                      Скачать шаблон
                    </Button>
                  </Row>
                  <Row
                    style={{ marginTop: '15px' }}
                  >
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      onClick={async () => {
                        await MarketYandexApi.updateStocks({
                          data: {
                            shop: MARKETS_MAP[shop],
                            filter: {},
                            rules: {
                              fbsActiveUpdate: true
                            },
                            skladName: 'msk',
                            waitEnd: true,
                          }
                        })
                        setUpdate(!update)
                      }}
                    >
                      Отправить остатки
                    </Button>
                    <Button
                      style={{ marginLeft: '30px' }}
                      type={TYPE_BUTTONS.WHITE}
                      onClick={() => {
                        MarketYandexApi.excelStocksFbsActive({ data: { shop: MARKETS_MAP[shop] } })
                      }}
                    >
                      Скачать остатки
                    </Button>
                  </Row>
                </Column>

              }
              {isOwner && !isFbsRemainsMode && (
                <>
                  <Row style={{ marginTop: '10px' }}>
                    <Button
                      onClick={() => MarketYandexApi.loadCards({ data: { shop: MARKETS_MAP[shop] } })}
                      type={TYPE_BUTTONS.BLUE}
                      style={{ marginRight: '10px' }}
                    >
                      Выгрузить номенклатуры
                    </Button>
                    <Button
                      onClick={() => MarketYandexApi.loadPricesAndQuantum({ data: { shop: MARKETS_MAP[shop] } })}
                      type={TYPE_BUTTONS.WHITE}
                      style={{ marginRight: '10px' }}
                    >
                      Выгрузить цены и кванты
                    </Button>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Button
                      onClick={() => MarketYandexApi.loadCards({ data: { shop: MARKETS_MAP[shop], onlyNew: true } })}
                      type={TYPE_BUTTONS.BLUE}
                      style={{ marginRight: '10px' }}
                    >
                      Выгрузить новые номенклатуры
                    </Button>
                    <Button
                      onClick={() => MarketYandexApi.loadPricesAndQuantum({ data: { shop: MARKETS_MAP[shop], onlyNew: true } })}
                      type={TYPE_BUTTONS.WHITE}
                      style={{ marginRight: '10px' }}
                    >
                      Выгрузить цены и кванты для новинок
                    </Button>
                  </Row>
                  <Row style={{ marginTop: '15px' }}>
                    <Column>
                      <SendButton
                        sendApi={MarketYandexApi.updateByExcel}
                        sendData={{ data: { shop: MARKETS_MAP[shop] } }}
                      >
                        Подгрузить данные
                      </SendButton>{' '}
                      <Link
                        download
                        href={'/template_yandex.xlsx'}
                        name="Шаблон яндекс товары"
                        className={styles.link_download}
                      >
                        Скачать шаблон
                      </Link>
                    </Column>
                  </Row>
                </>
              )}
            </Column>
            {isOwner && !isFbsRemainsMode && (
              <Column className={styles.stosks_column}>
                <Select
                  label="Поставщик"
                  select={provider}
                  valueFn={(p) => p.name}
                  list={providers}
                  onSelect={(v) => changeProvider(v)}
                />

                <Row style={{ marginTop: '10px' }}>
                  <Button
                    type={TYPE_BUTTONS.BLUE}
                    onClick={() => updateProviderStocks(provider.id)}
                    style={{ marginRight: '10px' }}
                    disabled={true}
                  >
                    Обновить остатки и цены
                  </Button>
                  <Button
                    type={TYPE_BUTTONS.RED}
                    onClick={() => updateProviderStocks(provider.id, true)}
                    style={{ marginRight: '10px' }}
                    disabled={true}
                  >
                    Обнулить остатки
                  </Button>
                  <Button type={TYPE_BUTTONS.WHITE} onClick={() => updateProviderPrice(provider.id)}>
                    Пересчитать цены
                  </Button>
                </Row>
                <MarketProvidersDateUpdate providerData={providerData} />

                <Row style={{ marginTop: '10px' }}>
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    onClick={() => updateWarehouseStocks()}
                    style={{ marginRight: '10px' }}
                  >
                    Обновить остатки со склада
                  </Button>
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    onClick={() => updateWarehouseStocks(true)}
                    style={{ marginRight: '10px' }}
                  >
                    Обнулить остатки со склада
                  </Button>
                </Row>
              </Column>
            )}
          </Row>
        </WhiteBlock>
        {isFbsRemainsMode && (
          <>
            <WhiteBlock
              style={{ minWidth: '400px' }}
              title="Управление отгрузками FBS" left={true} minimize={true} openBlock={true}>
              <div
                style={{ alignSelf: 'center', width: 'stretch' }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', height: 'stretch', justifyContent: 'space-between' }}>
                  <div style={{ marginTop: '0px', textAlign: 'center', fontWeight: 'bold', color: '#0000009e' }}>Рассчёт цен</div>
                  {/* <div style={{ border: '2px solid #0000006c', padding: '15px', marginTop: '15px', borderRadius: '5px', width: '320px' }}>
                    <Row style={{ justifyContent: 'space-between' }}>
                      <TextGrey>Коеффициент логистики, %</TextGrey>
                      <Input
                        center
                        style={{ width: '60px' }}
                        disabled={!isOwner}
                        value={marketInfo?.commission?.delivery_sort_center?.coef}
                        onBlur={async (v) => {
                          setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'wb', field: 'commission.delivery_sort_center.coef', value: +v } }).then(r => r.marketInfo))
                        }}
                      />
                    </Row>
                    <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                      <TextGrey>Логистика первого литра</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={true}
                        value={marketInfo?.commission?.delivery_sort_center?.first_liter_base}
                      // onBlur={async (v) => {
                      // const newSupply = await SuppliesApi.changeSupply({ data: { supplyId: supply.id, field: 'wb_info.tariff.delivery.liter', value: v } }).then(r => r.supply)
                      // }}
                      />
                    </Row>
                    <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                      <TextGrey>Логистика последующего литра</TextGrey>
                      <Input
                        center style={{ width: '60px' }}
                        disabled={true}
                        value={marketInfo?.commission?.delivery_sort_center?.step_liter_base}
                      // onBlur={async (v) => {
                      // setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'wb', field: 'commission.delivery_sort_center.step_liter_base', value: +v } }).then(r => r.marketInfo))
                      // }}
                      />
                    </Row>
                  </div> */}
                  <Row style={{ marginTop: '15px', justifyContent: 'space-between' }}>
                    <TextGrey>Маржинальность, %</TextGrey>
                    <Input
                      center style={{ width: '60px' }}
                      disabled={!isOwner}
                      value={marketInfo?.marginality?.percent}
                      onBlur={async (v) => {
                        setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'yandex', field: 'marginality.percent', value: +v } }).then(r => r.marketInfo))
                      }}
                    />
                  </Row>
                  <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                    <TextGrey>Маржинальность мин, руб.</TextGrey>
                    <Input
                      center style={{ width: '60px' }}
                      disabled={!isOwner}
                      value={marketInfo?.marginality?.rub}
                      onBlur={async (v) => {
                        setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'yandex', field: 'marginality.rub', value: +v } }).then(r => r.marketInfo))
                      }}
                    />
                  </Row>
                  <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                    <TextGrey>Повышенная комиссия, %.</TextGrey>
                    <Input
                      center style={{ width: '60px' }}
                      disabled={!isOwner}
                      value={marketInfo?.commission?.increased_commission?.percent}
                      onBlur={async (v) => {
                        setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'yandex', field: 'commission.increased_commission.percent', value: +v } }).then(r => r.marketInfo))
                      }}
                    />
                  </Row>
                  <Row style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                    <TextGrey>Стоимость короба, руб.</TextGrey>
                    <Input
                      center style={{ width: '60px' }}
                      disabled={!isOwner}
                      value={marketInfo?.common_commission?.box_cost}
                      onBlur={async (v) => {
                        setMarketInfo(await MarketCommonApi.changeMarketInfo({ data: { market: 'yandex', field: 'common_commission.box_cost', value: +v } }).then(r => r.marketInfo))
                      }}
                    />
                  </Row>
                  <Button
                    type={TYPE_BUTTONS.GREEN}
                    style={{
                      backgroundColor: false ? '#ed6e14d3' : '',
                      marginTop: '20px'
                    }}
                    disabled={!isOwner}
                    onClick={async () => {
                      await MarketYandexApi.updatePrices({ data: { shop: YANDEX_MARKETS_MAP[shop], skladName: 'msk', filter: { onlyActiveFbsProducts: true }, rules: {}, waitEnd: true } })
                      setUpdate(!update)
                    }}
                  >
                    Пересчитать цены
                  </Button>
                </div>
              </div>
            </WhiteBlock>
          </>
        )}
      </Row>
      <CatalogTableYandex
        parentUpdate={update}
        isFbsRemainsMode={isFbsRemainsMode}
        setIsFbsRemainsMode={setIsFbsRemainsMode}
        updateProviderPrice={updateProviderPrice}
        updateProviderStocksAndPrice={updateProviderStocks}
      />
    </Content>
  );
};

export default YandexPage;
